import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-pulldown',
  templateUrl: './pulldown.component.html',
  styleUrls: ['./pulldown.component.css'],
})
export class PulldownComponent implements OnInit {
  @Input()
  placeholder?: string;

  @Input()
  items?: { value?: string; label: string }[];

  @Input()
  selected?: string;

  @Output() selectedChange = new EventEmitter<string | undefined>();

  isFocused = false;

  constructor() {}

  ngOnInit(): void {}

  onChange(value: string) {
    this.selectedChange.emit(value);
  }

  /** プルダウンが展開された瞬間の処理 */
  onFocus() {
    // 選択された状態のフラグを建てる
    // このフラグを使って、プレースホルダーの役割となるoptionを無効化する
    this.isFocused = true;
  }
}
